import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    // component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
    component: Home
  },

  {
    path: '/about',
    name:'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/all-is-not-forgiven-by-john-kenneth-paranada',
    name:'Essay',
    component: () => import(/* webpackChunkName: "all-is-not-forgiven-by-john-kenneth-paranada" */ '../views/AllIsNotForgiven.vue')
  },
  {
    path: '/q-and-a',
    name:'QA',
    component: () => import(/* webpackChunkName: "q-and-a" */ '../views/QA.vue')
  },
  {
    path: '/pio-abad-and-frances-wadsworth-jones',
    name:'Pio',
    component: () => import(/* webpackChunkName: "pio-abad-and-frances-wadsworth-jones" */ '../views/PioFrances.vue')
  },
  {
    path: '/credits',
    name:'Credits',
    component: () => import(/* webpackChunkName: "credits" */ '../views/Credits.vue')
  },
  {
    path: '/restitution',
    name:'Restitution',
    component: () => import(/* webpackChunkName: "credits" */ '../views/Restitution.vue')
  },
  {
    // path: '/gallery',
    path: '/your-collection',
    name:'Gallery',
    component: () => import(/* webpackChunkName: "credits" */ '../views/Gallery.vue')
  },
  {
    path: '/ar',
    name:'AR',
    component: () => import(/* webpackChunkName: "credits" */ '../views/AR.vue')
  },
  // {
  //   path: '/camera',
  //   name: 'Camera',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/Camera.vue')
  // },
  // {
  //   path: '/gallery',
  //   name: 'Gallery',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/Gallery.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
